module.exports = __webpack_public_path__ + "img/93.76201765.webp";